
const cabinetDocumentsType = {
  CABINET_DOCUMENTS_TABLE_STATE_SET: 'CABINET_DOCUMENTS/TABLE_STATE_SET',
  CABINET_DOCUMENTS_TABLE_STATE_RESET: 'CABINET_DOCUMENTS/TABLE_STATE_RESET',
};
export default cabinetDocumentsType;
